import { Marker } from '@react-google-maps/api';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { DefaultMarker } from 'components/UI/MapMarkerSVGs/MapMarkerSVGs';
import { importantPlaceIcons } from 'shared/utility';

const iconMapMarker = (props) => {
  // const markerColor = props.markerColor ? props.markerColor.replace('#', '%23') : '%23c80000';
  const importantPlaceIcon = importantPlaceIcons.find((place) => place.name === props.locationIcon)
    ? importantPlaceIcons.find((place) => place.name === props.locationIcon)
    : null;
  const mapMarker = importantPlaceIcon ? (
    <importantPlaceIcon.markerSVG fillColor={props.markerColor} />
  ) : (
    <DefaultMarker fillColor={props.markerColor} />
  );
  const iconUrl = `data:image/svg+xml;utf-8, ${encodeURIComponent(renderToStaticMarkup(mapMarker))}`;

  return (
    <Marker
      icon={{
        url: iconUrl,
        labelOrigin: new window.google.maps.Point(18, 19),
      }}
      onPositionChanged={props.moveMarker}
      position={props.geoLocation}
    />
  );
};

export default iconMapMarker;
